import { ChainId } from '@pancakeswap/sdk'
import BigNumber from 'bignumber.js/bignumber'
import { BIG_TEN } from 'utils/bigNumber'

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

export const BSC_BLOCK_TIME = 3

export const EXPLORER_URLS = {
  [ChainId.OP_MAINNET]: 'https://optimistic.etherscan.io/',
  [ChainId.HEIF_LAYER]: 'https://explorer.heifereum.com',
  [ChainId.OP_SEPOLIA]: 'https://sepolia-optimism.etherscan.io',
  [ChainId.SEPOLIA]: 'https://sepolia.etherscan.io',
  [ChainId.POLYGON]: 'https://polygonscan.com/',
  [ChainId.BASE]: 'https://basescan.org/',
  [ChainId.ARBITRUM_ONE]: 'https://arbiscan.io/',
}

// EJOE_PER_BLOCK details
// 40 EJOE is minted per block
// 20 EJOE per block is sent to Burn pool (A farm just for burning cake)
// 10 EJOE per block goes to EJOE syrup pool
// 9 EJOE per block goes to Yield farms and lottery
// EJOE_PER_BLOCK in config/index.ts = 40 as we only change the amount sent to the burn pool which is effectively a farm.
// EJOE/Block in src/views/Home/components/CakeDataRow.tsx = 15 (40 - Amount sent to burn pool)
export const EJOE_PER_BLOCK = 40
export const BLOCKS_PER_YEAR = (60 / BSC_BLOCK_TIME) * 60 * 24 * 365 // 10512000
export const EJOE_PER_YEAR = EJOE_PER_BLOCK * BLOCKS_PER_YEAR
export const BASE_URL = 'https://app.ejoe.network'
export const BASE_ADD_LIQUIDITY_URL = `${BASE_URL}/add`
export const BASE_BSC_SCAN_URL = EXPLORER_URLS[ChainId.OP_MAINNET]
export const DEFAULT_TOKEN_DECIMAL = BIG_TEN.pow(18)
export const DEFAULT_GAS_LIMIT = 250000
export const AUCTION_BIDDERS_TO_FETCH = 500
export const RECLAIM_AUCTIONS_TO_FETCH = 500
export const AUCTION_WHITELISTED_BIDDERS_TO_FETCH = 500
export const IPFS_GATEWAY = 'https://ipfs.io/ipfs'
